module.exports = __webpack_public_path__ + "static/media/banner-products.54902c19.jpg";